export const SET = '/PutVehicleOnHold/set';
